import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["alert"]

  // If necessary, request storage access when the user clicks the link to start the rental flow.
  // This is only necessary in browsers that don't support partitioned cookies.
  async requestStorageAccess(e) {
    // If we already have cookie access, no need to do anything
    if (this.#checkCookieAccess()) return
    // If the browser doesn't support the Storage Access API, we can't do anything
    if (!document.hasStorageAccess) {
      this.#showFailureAlert()
      console.error("Storage Access API not supported")
      return
    }

    e.preventDefault()

    let success = false
    try {
      await document.requestStorageAccess()
      const hasStorageAccess = await document.hasStorageAccess()
      if (hasStorageAccess && this.#checkCookieAccess()) {
        // we need both storage and cookie access
        success = true
      }
    } catch (error) {
      console.error("Storage access request failed", error)
    }

    if (success) {
      // continue with the link's original action
      const linkEl = e.target.closest("a")
      window.location.href = linkEl.href
    } else {
      this.#showFailureAlert()
    }
  }

  // Check if we can set and read cookies
  #checkCookieAccess() {
    document.cookie = "cookie_access=true; path=/; SameSite=None; Secure; Partitioned"
    const cookieAccess = document.cookie.includes("cookie_access=true")
    document.cookie =
      "cookie_access=; path=/; SameSite=None; Secure; Partitioned; expires=Thu, 01 Jan 1970 00:00:00 GMT;"
    return cookieAccess
  }

  #showFailureAlert() {
    this.alertTarget.classList.remove("hidden")
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }
}
